import {AutomationTagHookPrefix} from 'common/src/modules/automation/automation.consts';

export default function addAutomationTag(tagValue: string) {
  if (!tagValue) return;

  return {
    [AutomationTagHookPrefix]: tagValue.toLowerCase(),
  };
}
